
export const ArrowUp = (props : any) => {
    return (
        <svg width="10" height="13" viewBox="0 0 10 13" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.812 6.698h2.71v5.351c0 .27.214.49.478.49s.478-.22.478-.49V6.698h2.71a.475.475 0 0 0 .419-.253.499.499 0 0 0-.014-.498L5.405.767A.476.476 0 0 0 5 .54a.476.476 0 0 0-.405.228l-3.188 5.18a.503.503 0 0 0-.014.498.476.476 0 0 0 .419.253z" fill={props.color || '#293359'} fillRule="evenodd" />
        </svg>
    );
}

